// extracted by mini-css-extract-plugin
export var downArrow = "_b2-0";
export var infoTooltipIcon = "_b2-3";
export var label = "_b2-1";
export var optionCard = "_b2-4";
export var upArrow = "_b2-2";